import $ from 'jquery';
import formatSection from './formatSection';

export default () => {
  $(document).on('shopify:section:load', (e) => {
    formatSection(`[data-section-id="${e.detail.sectionId}"]`);
  });
};